import React from 'react'

import { Button, ButtonClean, ModalBox } from '@fourthwall/components'

type Props = {
  close: () => void
}

export const BundleFeatureModal = ({ close }: Props) => {
  return (
    <ModalBox
      size="small"
      title="Unable to create a bundle"
      onClose={close}
      buttons={[
        <Button label="Cancel" appearance="secondary" onClick={close} />,
        <Button
          label="Contact support"
          appearance="primary"
          href="mailto:support@fourthwall.com"
        />,
      ]}
    >
      <p>
        Your custom theme does not support product bundles. Please{' '}
        <ButtonClean
          appearance="secondary"
          href="mailto:support@fourthwall.com"
          label="contact our support"
        />{' '}
        or your partner manager to enable this feature.
      </p>
    </ModalBox>
  )
}
